import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Welcome from "./Slides/Welcome";
import Thankyou from "./Slides/Thankyou";
import Feedback from "./Slides/Feedback";
import axios from "axios";
import routes from "../../../app/routes";

export default function Index() {
  const [collection, setCollection] = useState([]);
  const [currentPosition, setCurrentPosition] = useState(0);

  const [loaded, setLoaded] = useState(true);
  const [show, setShow] = useState(true);

  const closeForm = () => setShow(false);

  const nextSlide = () => {
    setCurrentPosition(currentPosition + 1);
  };

  const [skipping, setSkipping] = useState(false);

  const skip = ({ type, ids }) => {
    if (skipping) {
      return;
    }
    setSkipping(true);
    axios
      .post(routes.api.required_actions.skip, {
        type: type,
        ids: ids,
      })
      .then((resp) => {
        if (ids == undefined) {
          closeForm();
        } else {
          setSkipping(false);
          nextSlide();
        }
      });
  };

  const updateCollection = () => {
    axios
      .get(routes.api.required_actions.list, {
        params: { type: "session_feedback" },
      })
      .then((resp) => {
        setLoaded(false);
        let steps = [
          { type: "welcome", position: 1 },
          ...resp.data.data.map((item, index) => {
            return {
              type: "feedback",
              position: index + 2,
              id: item.id,
              ...item.attributes,
            };
          }),
          { type: "thank_you", position: 4 },
        ];
        setCollection(steps);
      });
  };

  useEffect(() => {
    updateCollection();
  }, []);

  return (
    <Modal
      className="student inmodal"
      show={show}
      onHide={closeForm}
      keyboard={false}
      backdrop="static"
    >
      {loaded && (
        <div className="slide">
          <p className="text-center" style={{ paddingTop: "300px" }}>
            Please, wait...
          </p>
        </div>
      )}

      {!loaded && (
        <div
          className="slide-wrapper"
          style={{ marginTop: `${-currentPosition * 600}px` }}
        >
          {collection.map((step, index) => {
            return (
              <div className="slide" key={index}>
                {step.type == "welcome" && (
                  <Welcome
                    nextSlide={nextSlide}
                    skip={skip}
                    skipping={skipping}
                  />
                )}
                {step.type == "feedback" && (
                  <Feedback
                    step={step}
                    nextSlide={nextSlide}
                    skip={skip}
                    skipping={skipping}
                  />
                )}
                {step.type == "thank_you" && <Thankyou closeForm={closeForm} />}
              </div>
            );
          })}
        </div>
      )}
    </Modal>
  );
}
